import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="container">
      <section className="page-section">
        <h1 className="page-title">404 - 页面未找到</h1>
        <p className="page-subtitle">
          很抱歉，您访问的页面不存在或已被移除。
        </p>
        <div className="text-center">
          <Link to="/" className="feature-link">
            返回首页
          </Link>
        </div>
      </section>
    </div>
  );
}

export default NotFound; 